import { render, staticRenderFns } from "./GeneralTenantFileDownloadBtn.vue?vue&type=template&id=60ae31c5"
import script from "./GeneralTenantFileDownloadBtn.vue?vue&type=script&lang=js"
export * from "./GeneralTenantFileDownloadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports